<!--

    Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<form [formGroup]="formService.form">
  <odc-instant-search-editor
    data-test-id="zustaendige-stelle-instant-search"
    [formControlName]="'search'"
    [searchResultItemList]="searchResultItemList"
    [label]="label"
    placeholder="Name des Amts oder Adresse eingeben"
    [focusOnSearchField]="focusOnSearchField"
    (searchQueryChanged)="searched.emit($event.searchBy)"
    (searchQueryCleared)="clearSearchResult.emit()"
    (searchResultsClosed)="clearSearchResult.emit()"
  >
    <alfa-search-zustaendige-stelle-result-items
      data-test-id="search-zustaendige-stelle-result-items"
      [instantSearchResults]="instantSearchResults"
      (selectSearchResult)="selectSearchResult.emit($event)"
    />
  </odc-instant-search-editor>
</form>
